import { apiClient } from "@/api/api-client";
import { ApiResponse } from "@/types/api-response";
import {
  Fulfillment,
  FulfillmentCreateRequest,
  FulfillmentUpdateFeeRequest,
  FulfillmentUpdateRequest,
} from "@/types/fulfillment-type";
import { endpoints } from "./endpoints/endpoints";

export async function getFulfillment(
  id: string
): Promise<ApiResponse<Fulfillment>> {
  try {
    const response = await apiClient.get<Fulfillment, void>(
      endpoints.fulfillment.get(id)
    );
    return response as ApiResponse<Fulfillment>;
  } catch (error) {
    console.error("Error getting fulfillment:", error);
    throw error;
  }
}

export async function createFulfillment(
  request: FulfillmentCreateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.post(
      endpoints.fulfillment.create,
      request
    );
    console.log("Fulfillment created:", response.data);
    return response.data as ApiResponse<any>;
  } catch (error) {
    console.error("Error creating fulfillment:", error);
    throw error;
  }
}

export async function updateFulfillment(
  id: string,
  request: FulfillmentUpdateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.put(
      endpoints.fulfillment.update(id),
      request
    );
    console.log("Fulfillment updated:", response.data);
    return response.data as ApiResponse<any>;
  } catch (error) {
    console.error("Error updating fulfillment:", error);
    throw error;
  }
}

export async function deleteFulfillment(
  id: string
): Promise<ApiResponse<Fulfillment>> {
  try {
    const response = await apiClient.delete<Fulfillment>(
      endpoints.fulfillment.delete(id)
    );
    return response;
  } catch (error) {
    console.error("Error deleting fulfillment:", error);
    throw error;
  }
}

export async function updateFulfillmentCost(
  id: string,
  request: FulfillmentUpdateFeeRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.put(
      endpoints.fulfillment.updateCost(id),
      request
    );
    return response;
  } catch (error) {
    console.error("Error updating fulfillment cost:", error);
    throw error;
  }
}

export async function createGoodRequest(
  id: string
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.post<any, any>(
      endpoints.fulfillment.createGoodRequest(id)
    );
    return response;
  } catch (error) {
    console.error("Error creating good request:", error);
    throw error;
  }
}
